import { WEBSITE_DISPLAY_GROUP } from "@cielo-blu-team/amazon-fee-lib-v2";

/**
 * カテゴリマップ
 */

export const CATEGORY_MAP: any = Object.values(WEBSITE_DISPLAY_GROUP)
  .map((category: any) => ({ [category.value]: category.label }))
  .reduce((acc, value) => ({ ...acc, ...value }));
